// extracted by mini-css-extract-plugin
export default {"popup":"DisplayStageDelete_popup__YW8Uj","canvas":"DisplayStageDelete_canvas__nEejG","buttonContainer":"DisplayStageDelete_buttonContainer__x8QUc"};